import React from "react";

const abhaInputFieldName = "abha-phone-input";

function AadhaarInputComponent({
  initialValue = "",
  onChange = () => {},
  className = "",
}: {
  initialValue: string;
  onChange: (val: string) => void;
  className?: string;
}) {
  const inputRef: any = React.useRef();
  const [aadharNumber, setAadharNumber] = React.useState<string[]>([
    initialValue.substring(0, 4),
    initialValue.substring(4, 8),
    initialValue.substring(8, 12),
  ]);

  React.useEffect(() => {
    const indexToFocus = Math.ceil(initialValue.length / 4) - 1;
    inputRef.current[`aadhaar${indexToFocus < 0 ? 0 : indexToFocus}`]?.focus();
  }, []);

  return (
    <form
      autoComplete="off"
      ref={inputRef}
      className={`dr-flex space-x-12 ${className}`}
    >
      {[0, 1, 2].map((i) => {
        return (
          <div
            key={i}
            className={
              "dr-bg-darwin-touch-neutral-0 dr-border-1 dr-border-darwin-touch-neutral-200 dr-rounded-8 dr-flex-grow"
            }
          >
            <input
              id={i === 0 ? abhaInputFieldName : undefined}
              type="number"
              name={`aadhaar${i}`}
              value={aadharNumber?.[i]}
              placeholder={"xxxx"}
              onChange={(e) => {
                const secValue = e.target.value;
                if (secValue.length > 4) {
                  return;
                }

                if (secValue.length === 4 && i < 2) {
                  inputRef.current[`aadhaar${i + 1}`].focus();
                }

                const res = [...aadharNumber];
                res[i] = secValue;

                onChange(res.join(""));
                setAadharNumber(res);
              }}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  if (!aadharNumber?.[i] && i !== 0) {
                    inputRef.current[`aadhaar${i - 1}`].focus();
                  }
                }
              }}
              className="BodyRegular dr-outline-none dr-bg-transparent dr-w-full dr-p-12"
            />
          </div>
        );
      })}
    </form>
  );
}

export default AadhaarInputComponent;
